export const AuthEventName = {
  submitPasswordsForm: "submitPasswordsForm",
  submitPasswordsSuccess: "submitPasswordsSuccess",
  submitLoginForm: "submitLoginForm",
  submitLoginSuccess: "submitLoginSuccess",
  submitLoginFailed: "submitLoginFailed",
  bookInvestmentSession: "bookInvestmentSession",
  forgotPassword: "forgotPassword",
  submitResetPasswordForm: "submitResetPasswordForm",
  viewResetPasswordRequestFinalStep: "viewResetPasswordRequestFinalStep",
} as const;

export type AuthEventName = (typeof AuthEventName)[keyof typeof AuthEventName];
